export default __webpack_public_path__ + "static/rainbow-e9efda192e59d90be268a821783a392b.png";